import {style} from 'typestyle';

import {CommonStyles} from '~commonInfra/styles/CommonStyles';
import {cssClass} from '~src/style';

const KMS_IN_ONLINE_SETTINGS = 'kms-in-online-settings';

export const siteEncryptionKeyMetadata = style({
  fontSize: CommonStyles.Sizes.NormalFontSize,
  fontWeight: 'normal',
  marginTop: CommonStyles.Sizes.SmallSpace,
  display: 'inline-block',
  verticalAlign: 'top',
  whiteSpace: 'nowrap',
  width: '75%'
});

export const siteEncryptionKeyMetadataEntry = style({
  paddingTop: CommonStyles.Sizes.SmallSpace,
  paddingBottom: CommonStyles.Sizes.SmallSpace
});

export const keyHistoryButton = cssClass(KMS_IN_ONLINE_SETTINGS, 'key-history-button', {
  marginTop: CommonStyles.Sizes.MediumSpace,
  marginBottom: CommonStyles.Sizes.MediumSpace,
  display: 'flex',
  alignItems: 'center'
});

export const generateKeyButton = cssClass(KMS_IN_ONLINE_SETTINGS, 'key-history-button', {
  marginTop: CommonStyles.Sizes.MediumSpace,
  marginBottom: CommonStyles.Sizes.MediumSpace,
  display: 'flex',
  float: 'right',
  alignItems: 'center'
});

